'use strict';

var _ = require('lodash');
var CONST = require('../constants').connect;
var AuthModel = require('standard-vote/app/scripts/models/auth');

module.exports = AuthModel.extend({

    _submittedVotes: 0,

    defaults: {
        authType: null,
        isAuthorized: false,
        userImage: null,
        userName: null,
        userID: null
    },

    initializeType: function () {

        // if FB is disabled, set authType to email
        if (!this.facebook.isEnabled()) {
            this.set({ authType: CONST.AUTH_METHOD_EMAIL });
            return;
        }

        if (this.facebook.get('status') === null) {
            this.facebook.once('change:status', function () {
                this.initializeType();
            }.bind(this));
        } else {
            switch (this.facebook.get('status')) {
            case 'connected':
                this.setUpFBUser();
                this.set({ authType: CONST.AUTH_METHOD_FB });
                break;
            default:
                this.set({ authType: CONST.AUTH_METHOD_EMAIL });
                break;
            }
        }
    },

    setUpEmailUser: function (data) {

        this.set({
            authType: CONST.AUTH_METHOD_EMAIL,
            userName: data,
            userID: data,
            isAuthorized: true
        });
    },

    setUpFBUser: function () {

        if (!_.isNull(this.facebook.get('user'))) {

            var user = this.facebook.get('user');

            this.set({
                authType: CONST.AUTH_METHOD_FB,
                fbData: user,
                userImage: user.avatar,
                userName: user.name,
                userID: user.identifier,
                isAuthorized: true
            });

        } else {

            // Add listener for when the Facebook user data is available
            this.facebook.once('change:user', function () {
                console.log('waiting for user to initialize');
                this.setUpFBUser();

            }.bind(this));
        }

    },

    deAuthorize: function () {

        switch (this.get('authType')) {
        case CONST.AUTH_METHOD_FB:
            console.log('deauthorize facebook');
            this.facebook.logout();
            break;
        case CONST.AUTH_METHOD_EMAIL:
            console.log('deauthorize email');
            break;
        default:
            console.log('deauthorize default');
        }

        this.set(this.defaults);
    },

    getSubmittedVotes: function() {
        return this._submittedVotes;
    },

    setSubmittedVotes: function(votes) {
        this._submittedVotes = votes;
    }

});



// WEBPACK FOOTER //
// ./app/scripts/models/auth.js